// extracted by mini-css-extract-plugin
export default {"wrapdiv":"fifth_wrapdiv__Egoxk"};